import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Upload, Button, InputNumber, Row, Col, Tooltip, message, Spin } from 'antd';
import { createUseStyles } from 'react-jss'

import {CopyToClipboard} from 'react-copy-to-clipboard';

import { UploadOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { errorCatch, GET } from 'fennec-ui';

const { Title } = Typography;

export default function RassilkaSourceText(props) {
    const { auth, object } = props;

    return (
        <div>
            <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                <CopyToClipboard text={object?.tekst}
                    onCopy={() => message.success("Скопировано")}>
                    <Button>Скопировать</Button>
                </CopyToClipboard>
            </div>

            <pre>
                {object?.tekst}
            </pre>
        </div>
    );
}
